<script setup lang="ts">
import { CREDIT_PACKS, packBonusPercent, type CreditPack } from '@skiphr/contracts'
import { CreditCard, LoaderCircle } from 'lucide-vue-next'
import { httpsCallable } from 'firebase/functions'
import { ref } from 'vue'
import { firebaseClient } from '@/firebase'

const busy = ref('')
const error = ref('')
const dollars = (cents: number) => `$${(cents / 100).toLocaleString('en-US')}`

async function buy(pack: CreditPack): Promise<void> {
  busy.value = pack.id
  error.value = ''
  try {
    const checkout = httpsCallable<{ packId: string; returnUrl: string }, { url: string }>(firebaseClient.functions, 'createCheckoutSession')
    const result = await checkout({ packId: pack.id, returnUrl: window.location.origin })
    window.location.assign(result.data.url)
  } catch (caught) {
    error.value = caught instanceof Error ? caught.message.replace('Firebase: ', '') : 'Checkout is unavailable.'
    busy.value = ''
  }
}
</script>

<template>
  <div class="credit-packs">
    <article v-for="pack in CREDIT_PACKS" :key="pack.id" class="credit-pack" :class="{ 'credit-pack--best': pack === CREDIT_PACKS.at(-1) }">
      <span class="eyebrow">{{ pack.name }}</span>
      <strong class="credit-pack__credits">{{ pack.credits.toLocaleString('en-US') }} <small>credits</small></strong>
      <span class="credit-pack__price">{{ dollars(pack.priceCents) }}</span>
      <span v-if="packBonusPercent(pack)" class="credit-pack__bonus">+{{ packBonusPercent(pack) }}% bonus credits</span>
      <span v-else class="credit-pack__bonus credit-pack__bonus--none">Pay as you go</span>
      <button class="button button--dark" type="button" :disabled="Boolean(busy)" @click="buy(pack)">
        <LoaderCircle v-if="busy === pack.id" :size="15" class="spin" /><CreditCard v-else :size="15" /> Buy
      </button>
    </article>
    <p v-if="error" class="form-error credit-packs__error">{{ error }}</p>
  </div>
</template>
